import Autocomplete from '../../../Shared/AutoCompleteInput/AutoCompleteInput';
import React, {useEffect, useRef, useState} from 'react';
import {showAppLoader, hideAppLoader} from '../../../Shared/Loader/LoaderSlice';
import ProviderManager from '../../../../provider/providerManager';
import {isMobile} from 'react-device-detect';
function CityInput(data) {
  const {store, props} = data;
  const cityRef = useRef();
  const [form, setForm] = useState({cityName: store.selectedAddress?.cityName ?? '', streetName: store.selectedAddress?.streetName ?? ''});
  const [cities, setCities] = useState([]);
  const [address, setAddress] = useState({
    city: {value: '', code: '', semel: '', error: ''},
  });
  const [addressInfo, setAddressInfo] = useState();

  useEffect(() => {
    if (data.isSubmit) {
      data.onSubmit({isValid: true, selectedAddress: addressInfo});
    }
  }, [data.isSubmit]);

  async function citySelectedChange(cityCode) {
    const selectedCity = cities.find((x) => x.cityCode === cityCode);
    if (selectedCity) {
      address.city = {value: selectedCity.cityName, code: cityCode, semel: selectedCity.citySemel, error: ''};
      setForm({...form});
      let addressInfo = {};
      addressInfo.cityCode = address.city.code;
      addressInfo.citySemel = address.city.semel;
      addressInfo.cityName = address.city.value;
      setAddressInfo(addressInfo);
    }
  }
  async function setSelectedAddress() {
    if (!store.selectedAddress || Object.keys(store.selectedAddress).length === 0) {
      return;
    }
    address.city = {
      value: store.selectedAddress.cityName,
      code: store.selectedAddress.cityCode,
      semel: store.selectedAddress.citySemel,
      error: '',
    };
    setAddress({...address});
  }
  useEffect(() => {
    (async function getCities() {
      showAppLoader();
      try {
        const result = await ProviderManager.getProviderData('getCities', []);
        if (result.errorCode == undefined) {
          setCities(result.Body);
          setSelectedAddress();
        }
      } catch (error) {
      } finally {
        hideAppLoader();
      }
    })();
    return () => {};
  }, [store.personalInfoMode]);

  return (
    <div style={isMobile ? {width: '90%'} : {width: 'unset'}}>
      {' '}
      <Autocomplete
        ref={cityRef}
        injectedValue={store.selectedAddress?.cityName ?? ''}
        form={form}
        autofocus={true}
        error={address.city.error}
        value={address.city.value}
        id='city'
        name='city'
        onSelectedChange={(e) => citySelectedChange(e.target.value)}
        suggestions={cities}
        dataKey='cityCode'
        dataValue='cityName'
        placeholder='שם יישוב'
        required='required'
      />
    </div>
  );
}

export default CityInput;
